<template>
  <topbar
    :titulo="$t('FINANCEIRO.COBRANCA')"
    :subtitulo="$t('FINANCEIRO.CARTA_COBRANCAS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
// Utils & Aux:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO.CAIXA') },
        { titulo: this.$t('FINANCEIRO.CARTA_COBRANCAS') },
      ],
    };
  },
  methods: {
    // FUNÇÕES AUXILIARES:
    cadastrar() {
      this.$emit('cadastrar', 'banco');
    },
  },
};
</script>
    